export default __webpack_public_path__ + "static/media/pgmico(9).08a1e477.png";